export const DEFAULT_FEEDBACK_SETTINGS = {
    "dialogs": {
        "isEnabled": true,
        "acceptComment": true
    },
    "faqs": {
        "isEnabled": true,
        "acceptComment": true
    },
    "searchassist": {
        "isEnabled": true,
        "acceptComment": true
    },
    "summary": {
        "isEnabled": true,
        "acceptComment": true
    }
}

export const DEFAULT_WIDGET_SETTINGS = {
    "isCustomisedLogoEnabled": {
        "isEnabled": false
    },
    "botEvents": {
        "fallback": {
            "isEnabled": true
        }
    },
    "isWidgetLandingEnabled": {
        "isEnabled": true,
        "tab": "assist"
    },
    "agentAssistWidgetEnabled": true,
    "isProactiveEnabled": true,
    "isAutoScrollEnabled": true,
    "isAgentCoachingEnabled": false,
    "isAgentResponseEnabled": true,
    "isAgentPlaybookEnabled": false,
    "isAgentResponseCopyEnabled": true,
    "isSearchAssistEnabled": true,
    "summarization": {
        "isEnabled": false,
        "canSubmit": false,
        model: {
            "type": "kore",
            "customTaskConfig": {
                "usecaseId": "",
                "refId": "",
                "dialogId": "",
                "taskRefId": "",
                "linkedBotId": ""
            }
        }
    },
    "transcripts": {
        "isEnabled": true,
    },
    "searchAssistConfig": {
        "isXODependant": false,
        "alwaysShow": false,
        "showAutoSuggestions": false,
        "fallback": false,
        "integrations": {
            "type": "basic",
            "config": {
                "script": ""
            }
        },
        "displayLines": 4
    },
    "urlOpenBehaviour": {
        "defaultBehaviour": true, // send an event
        "sendPostEvent": false
    },
    "sentiment": {
        "isEnabled": true,
    },
    "agentActions": {
        "sharingFormat": "original"
    },
    "showHelp": {
        "isEnabled": true,
        "documentation": {
            "isEnabled": true,
            "resource": ""
        },
        "faq": {
            "isEnabled": true,
            "resource": ""
        },
        "koreAcademy": {
            "isEnabled": true,
        }
    },
    "languageSettings": {
        "language": "en",
        "allowAgentSwitch": false
    },
    "feedback": DEFAULT_FEEDBACK_SETTINGS
}

